import { ReactComponent as CloseIcon } from "../assets/icons/x.svg"
import { ReactComponent as AppIconLogo } from "../assets/icons/app-icon-logo.svg"


export function NotificationView({ title, body, onClose }: { title: string; body: string; onClose: () => void }) {
  return (
    <div
      style={{ backdropFilter: "blur(45px)", backgroundBlendMode: "soft-light, normal, luminosity", background: "linear-gradient(0deg, rgba(0, 0, 0, 0.50) 0%, rgba(0, 0, 0, 0.50) 100%), linear-gradient(0deg, rgba(255, 255, 255, 0.50) 0%, rgba(255, 255, 255, 0.50) 100%), rgba(171, 171, 171, 0.50)" }}
      className="fixed top-2 right-2 max-w-[400px] flex flex-col gap-2 bg-black bg-opacity-50 flex items-center justify-center rounded-[12px] p-4">
      <div className="flex items-center justify-between w-full">
        <div className="flex items-center gap-2">
          <AppIconLogo />
          <h1 className="text-black/20 font-medium text-xs">PRAXISPRO</h1>
        </div>
        <button onClick={onClose}>
          <CloseIcon className="w-4 h-4" />
        </button>
      </div>
      <p className="text-black/50 text-sm font-bold">{body}</p>
    </div>
  );
}